import ConsentModule from "./ConsentModule";
var consent_module_default = ConsentModule;
export {
  consent_module_default as default
};
